<app-compatibility-card>
  <h3>{{ "compatibility.environment.title" | translate }}</h3>
  <h4>{{ "compatibility.environment.subtitle" | translate }}</h4>
  <div class="buttons-wrapper">
    <button
      class="btn"
      [class.active]="(selectedEnvironment$ | async) === 'ios'"
      (click)="onSelectEnvironment('ios')"
    >
      <span class="icon icon-apple"></span>
      <span>{{
        "compatibility.environment.technologies.ios" | translate
      }}</span>
    </button>
    <button
      class="btn"
      [class.active]="(selectedEnvironment$ | async) === 'android'"
      (click)="onSelectEnvironment('android')"
    >
      <span class="icon icon-android"></span>
      <span>{{
        "compatibility.environment.technologies.android" | translate
      }}</span>
    </button>
    <button
      class="btn"
      [class.active]="(selectedEnvironment$ | async) === 'all'"
      (click)="onSelectEnvironment('all')"
    >
      <span>{{
        "compatibility.environment.brand-list-button" | translate
      }}</span>
    </button>
  </div>
</app-compatibility-card>
